import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("creatorV3", ["dateCalendarModalFooter"]),
  },
};
